/* Luminaire France — Product Grid JS */

(function () {
  'use strict';

  /* =========================================================
     COUPS DE CŒUR
     ========================================================= */

  var LF_WISHLIST_KEY = 'luminaire_france_wishlist_v1';

  function lfWishlistRead() {
    try {
      var raw = localStorage.getItem(LF_WISHLIST_KEY);

      if (!raw) return [];

      var value = JSON.parse(raw);

      return Array.isArray(value)
        ? value.map(String)
        : [];

    } catch (e) {
      return [];
    }
  }

  function lfWishlistWrite(list) {
    try {
      localStorage.setItem(
        LF_WISHLIST_KEY,
        JSON.stringify(list)
      );
    } catch (e) {}
  }

  function lfWishlistCount() {
    return lfWishlistRead().length;
  }

  function lfUpdateWishlistCounter() {

    var count = lfWishlistCount();

    document.querySelectorAll(
      '[data-lf-wishlist-count], .lf-wishlist-header__count'
    ).forEach(function (el) {

      el.textContent = String(count);

      el.setAttribute(
        'data-count',
        String(count)
      );

      el.hidden = false;

    });

    document.dispatchEvent(
      new CustomEvent(
        'lf:wishlist:updated',
        {
          detail: {
            count: count
          }
        }
      )
    );

    return count;
  }

  function lfSyncWishlistButtons() {

    var list = lfWishlistRead();

    document.querySelectorAll(
      '[data-lf-heart-button]'
    ).forEach(function (btn) {

      var id = String(
        btn.getAttribute(
          'data-lf-product-id'
        ) || ''
      );

      var active =
        id &&
        list.indexOf(id) !== -1;

      btn.classList.toggle(
        'is-active',
        !!active
      );

      btn.setAttribute(
        'aria-pressed',
        active ? 'true' : 'false'
      );

      btn.setAttribute(
        'aria-label',
        active
          ? 'Retirer des coups de cœur'
          : 'Ajouter aux coups de cœur'
      );

    });

    lfUpdateWishlistCounter();
  }

  function lfToggleWishlist(btn) {

    var id = String(
      btn.getAttribute(
        'data-lf-product-id'
      ) || ''
    );

    if (!id) return;

    var list = lfWishlistRead();

    var index = list.indexOf(id);

    var active;

    if (index === -1) {

      list.push(id);

      active = true;

    } else {

      list.splice(index, 1);

      active = false;

    }

    lfWishlistWrite(list);

    /*
     * Mise à jour immédiate du bouton
     */

    btn.classList.toggle(
      'is-active',
      active
    );

    btn.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );

    btn.setAttribute(
      'aria-label',
      active
        ? 'Retirer des coups de cœur'
        : 'Ajouter aux coups de cœur'
    );

    /*
     * Mise à jour immédiate du compteur
     */

    lfUpdateWishlistCounter();
  }

  document.addEventListener(
    'click',
    function (event) {

      var btn =
        event.target.closest(
          '[data-lf-heart-button]'
        );

      if (!btn) return;

      event.preventDefault();
      event.stopPropagation();

      lfToggleWishlist(btn);

    },
    true
  );

  function lfStartWishlist() {

    lfSyncWishlistButtons();

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      lfStartWishlist,
      {
        once: true
      }
    );

  } else {

    lfStartWishlist();

  }

  /*
   * Synchronisation entre onglets
   */

  window.addEventListener(
    'storage',
    function (event) {

      if (
        event.key ===
        LF_WISHLIST_KEY
      ) {

        lfSyncWishlistButtons();

      }

    }
  );

  /*
   * API conservée pour le menu
   * et la page Coups de cœur
   */

  window.lfUpdateWishlistCounter =
    lfUpdateWishlistCounter;

  window.lfSyncWishlistButtons =
    lfSyncWishlistButtons;


  /* =========================================================
     ANCRES SEO
     ========================================================= */

  function lfSplitAnchors(value) {

    if (!value) {
      return [];
    }

    return value
      .split(/[,;|\n\r]+/)
      .map(function (item) {

        return item.trim();

      })
      .filter(function (item) {

        return item.length > 0;

      });

  }

  function lfRandomAnchor(value) {

    var anchors =
      lfSplitAnchors(value);

    if (!anchors.length) {
      return '';
    }

    return anchors[
      Math.floor(
        Math.random() *
        anchors.length
      )
    ];

  }

  function lfChooseAnchor(card) {
    if (card.closest('#lf36-produits-collection')) {
      var button = card.querySelector('[data-lf-anchor-button]');
      return button ? (button.getAttribute('data-lf-product-short-label') || '') : '';
    }
    return 'Découvrir';
  }

  function lfApplyAnchors(container) {

    var cards =
      container.querySelectorAll(
        '.lf-product-card'
      );

    cards.forEach(function (card) {

      var text =
        card.querySelector(
          '[data-lf-anchor-text]'
        );

      var button =
        card.querySelector(
          '[data-lf-anchor-button]'
        );

      if (!text || !button) {
        return;
      }

      var selected =
        lfChooseAnchor(card);

      text.textContent =
        selected;

      var title =
        card.querySelector(
          '.lf-product-title'
        );

      if (title) {

        button.setAttribute(
          'aria-label',
          'Voir la fiche du produit ' +
          (button.getAttribute('data-lf-product-full-title') || title.textContent.trim())
        );

      }

    });

  }


  /* =========================================================
     PAGINATION
     ========================================================= */

  var LF_PRODUCTS_PER_PAGE = 24;

  function lfPaginate(container) {

    var cards =
      Array.prototype.slice.call(
        container.querySelectorAll(
          '.lf-product-card'
        )
      );

    var pagination =
      container.parentElement.querySelector(
        '[data-lf-pagination]'
      );

    if (
      !pagination ||
      cards.length <=
      LF_PRODUCTS_PER_PAGE
    ) {

      cards.forEach(
        function (card) {

          card.style.display = '';

        }
      );

      if (pagination) {

        pagination.innerHTML = '';

      }

      return;
    }

    var totalPages =
      Math.ceil(
        cards.length /
        LF_PRODUCTS_PER_PAGE
      );

    var currentPage = 1;

    function renderPage() {

      var start =
        (currentPage - 1) *
        LF_PRODUCTS_PER_PAGE;

      var end =
        start +
        LF_PRODUCTS_PER_PAGE;

      cards.forEach(
        function (card, index) {

          card.style.display =
            index >= start &&
            index < end
              ? ''
              : 'none';

        }
      );

      pagination.innerHTML = '';


      /* PRÉCÉDENT */

      var previous =
        document.createElement(
          'button'
        );

      previous.type = 'button';

      previous.className =
        'lf-pagination-arrow';

      previous.textContent = '‹';

      previous.setAttribute(
        'aria-label',
        'Page précédente'
      );

      previous.disabled =
        currentPage === 1;

      previous.addEventListener(
        'click',
        function () {

          if (
            currentPage > 1
          ) {

            currentPage--;

            renderPage();

          }

        }
      );

      pagination.appendChild(
        previous
      );


      /* NUMÉROS */

      for (
        var page = 1;
        page <= totalPages;
        page++
      ) {

        var button =
          document.createElement(
            'button'
          );

        button.type = 'button';

        button.textContent =
          page;

        button.setAttribute(
          'aria-label',
          'Page ' + page
        );

        if (
          page === currentPage
        ) {

          button.className =
            'is-active';

          button.setAttribute(
            'aria-current',
            'page'
          );

        }

        button.addEventListener(
          'click',
          (function (
            selectedPage
          ) {

            return function () {

              currentPage =
                selectedPage;

              renderPage();

            };

          })(page)
        );

        pagination.appendChild(
          button
        );

      }


      /* SUIVANT */

      var next =
        document.createElement(
          'button'
        );

      next.type = 'button';

      next.className =
        'lf-pagination-arrow';

      next.textContent = '›';

      next.setAttribute(
        'aria-label',
        'Page suivante'
      );

      next.disabled =
        currentPage ===
        totalPages;

      next.addEventListener(
        'click',
        function () {

          if (
            currentPage <
            totalPages
          ) {

            currentPage++;

            renderPage();

          }

        }
      );

      pagination.appendChild(
        next
      );

    }

    renderPage();

  }


  /* =========================================================
     INITIALISATION DE LA GRILLE
     ========================================================= */

  function lfInitProductGrid() {

    var containers =
      document.querySelectorAll(
        '.lf-gallery-noel, .lf-gallery-other'
      );

    containers.forEach(
      function (container) {

        lfApplyAnchors(
          container
        );

        lfPaginate(
          container
        );

      }
    );

  }

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      lfInitProductGrid
    );

  } else {

    lfInitProductGrid();

  }

})();